var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm._baskets),function(fbaBasketProduct){return _c('FbaBasketProduct',{key:fbaBasketProduct.id,attrs:{"fba-basket-product":fbaBasketProduct}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }